import clsx from 'clsx';
import { ButtonHTMLAttributes, Ref } from 'react';
import * as styles from './clearButton.css';

export interface ClearButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  fullWidth?: boolean;
  ref?: Ref<HTMLButtonElement>;
}

export const ClearButton = ({
  type = 'button',
  children,
  className,
  fullWidth = false,
  disabled,
  ref: forwardedRef,
  ...props
}: ClearButtonProps) => {
  return (
    <button
      ref={forwardedRef}
      type={type}
      className={clsx([styles.clearButton({ fullWidth, disabled }), className])}
      disabled={disabled}
      {...props}>
      {children}
    </button>
  );
};
